<template>
  <div class="mini-illustration">
    <div class="mini-illustration__icon-wrap mini-illustration__icon-wrap--zip">
      <img class="mini-illustration__zip-icon" :src="iconZipColored" alt="zip" />
    </div>

    <div class="mini-illustration__icon-wrap mini-illustration__icon-wrap--loader">
      <LoaderNew class="mini-illustration__loader-icon" :border-width="5" />
    </div>
  </div>
</template>

<script setup lang="ts">
// Components
import LoaderNew from "@components/Loader/LoaderNew.vue";

// Icons
import iconZipColored from "@assets/icons/zip-colored-icon.svg";
</script>

<style scoped lang="scss">
// Mini illustration ==========================================================
.mini-illustration {
  aspect-ratio: 1/1;
  width: 130px;
  border-radius: 50%;
  position: relative;
  z-index: 0;
  overflow: hidden;
  background: rgba(220, 240, 240, 1);

  &__icon-wrap {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    inset: 0 auto auto 0;
    z-index: 1;

    &--zip {
      animation: moveZipIcon 3500ms ease-in-out infinite;
    }

    &--loader {
      animation: moveLoaderIcon 3500ms ease-in-out infinite;
    }
  }

  &__zip-icon {
    width: 47%;
  }

  @keyframes moveZipIcon {
    0% {
      transform: translateY(0);
    }
    45% {
      transform: translateY(0);
    }
    55% {
      transform: translateY(100%);
    }
    90% {
      transform: translateY(100%);
    }
    90.01% {
      transform: translateY(-100%);
    }
    100% {
      transform: translateY(0);
    }
  }

  &__loader-icon {
    width: 42%;
    aspect-ratio: 1/1;
  }

  @keyframes moveLoaderIcon {
    0% {
      transform: translateY(-100%);
    }
    45% {
      transform: translateY(-100%);
    }
    55% {
      transform: translateY(0);
    }
    90% {
      transform: translateY(0);
    }
    100% {
      transform: translateY(100%);
    }
  }
}
</style>
